// extracted by mini-css-extract-plugin
module.exports = {"questLayout":"questLayout__10SD0"};